module.exports = {
      id: "recipe-share-mail-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "svg-sprite-39dbc991ee8a2ec1b35aeef6495011e2.svg#recipe-share-mail",
      toString: function () {
        return this.url;
      }
    }